export const getCookie = (key: string) => {
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    const c = ca[i];
    const splitted = c.split('=');
    if (splitted[0].trim() === key && splitted[1] !== 'undefined') {
      return splitted[1];
    }
  }
  return '';
};

export const setCookie = async (key: string, value: string, expires = '') => {
  document.cookie = `${key}=${value};expires=${expires};`;
};

export const capitalizeLetter = (value: string | undefined | null) => {
  if (value) {
    const words = value.split(" ");
    for (let i = 0; i < words.length; i++) {
      words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }
    return words.join(" ");
  }
  return "";
};

export const capitalizeFirstLetter = (value: string | undefined | null) => {
  if (value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  } return value
};

export function toTitleCase(str: string) {
  return str
    .toLowerCase()
    .split(" ")
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export const isDevelopment = () => process.env.REACT_APP_MODE === "development";

export const isStaging = () => process.env.REACT_APP_MODE === "staging";

export const removeCookie = async (key: string) => {
  if (isDevelopment()) {
    document.cookie = `${key}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  } else {
    document.cookie = `${key}=; path=/; domain=.tiqs.in; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  }
};

export const removeCookiesOnLogout = () => {
  removeCookie("session");
  removeCookie("token");
  removeCookie("disclaimer");
};

export function formatTime(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(remainingSeconds).padStart(2, '0');
  return `${formattedMinutes}:${formattedSeconds}`;
}

export function formatDateddmmyyyy(dateString: string) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

export function camelCaseToNormal(str:string) {
  let result = str.replace(/([A-Z])/g, ' $1').trim();
  result = result.toLowerCase().replace(/(^|\s)([a-z])/g, (match, p1, p2) => p1 + p2.toUpperCase());
  return result;
}
